import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/confirm-dialog/confirm-dialog.component';
import { CommonService } from 'src/app/services/common.service';
import { isNullOrEmpty } from 'src/Utility/StringValidation';
declare const copyToClipboard: any;
declare var $;

@Component({
  selector: 'app-agentendpoints',
  templateUrl: './agentendpoints.component.html',
  styleUrls: ['./agentendpoints.component.scss']
})


export class AgentendpointsComponent {
  isNullOrEmpty = isNullOrEmpty;
  reactiveFormroute=this._fb.group({ routename: '' });
  reactiveFormagent=this._fb.group({agentname:''});

  reactiveFormsubmit=this._fb.group(
    { selectedAgentID: ['',Validators.required],
      selectedRouteID:'',
      selectedUrlKey:['',Validators.required],
      selectedUrlValue:['',Validators.required],
      Params:''
     }
  );
  modalHeader:string="Create agent endpoint";
  agentuniqueid:string='';
  routeuniqueid:string='';
  selectedrouteId:string='';
  selectedrouteDisplayName:string='';
  saveSelectedrouteId:string='';
  saveSelectedrouteDisplayName:string=''
  pipelineselectclass:string='';
  isLoadingResult:boolean;
  RouteNameListPipeline:any[]=[];
  notfounddata:boolean;
  keywordsearch = 'displayname';
  agentendpointlist:any[]=[];
  isLoadingagent:boolean;
  AgentNameList:any[]=[];
  selectedAgentguid='';
  selectedAgentName='';
  saveSelectedAgentguid:string='';
  saveSelectedAgentName:string='';
  isselect:any;
  agentendpointheader=["Agent ID","Route ID","URL Key","URL Value","Params","Action"];
  dynamicWidth:any
  isedit:boolean;
  selectedUrlValue:string='';
  selectedUrlKey:string='';
  selectedRouteID:string='';
  selectedAgentID:string='';
  Params:string='';
  pagerolepermisions: any[] = [];
  isLoadingResult1:boolean;
  isLoadingagent1:boolean;
  ispopup:boolean;

  constructor(private toastr: ToastrService, private _fb: FormBuilder,
      public service: CommonService, private ngxUiLoaderService: NgxUiLoaderService,
      private modalService: NgbModal,public dialog: MatDialog) {
    }
    ngOnInit() {
      const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'agentendpoint').MenuId;
    const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
    actionitems.forEach(element => {
      this.pagerolepermisions[element.MenuName] = true;
    })
    }
    ngOnDestroy(){
      this.reset();
    }

  getRouteName(event: any) {
    var val = event;
    if (val) {
      if (Number(val.length) + Number(1) > 3) {
        this.ispopup?this.isLoadingResult1=true:this.isLoadingResult = true;
        var url = "api/Routes/GetByDisplayName?name=" + val + "&version=2";
        this.isedit?this.ngxUiLoaderService.start():'';
        this.service.getapiurl(url).subscribe({
          next: data => {
            this.isedit?this.ngxUiLoaderService.stop():'';
            this.ispopup?this.isLoadingResult1=false:this.isLoadingResult = false;
            this.RouteNameListPipeline = data as any[];
            this.RouteNameListPipeline.map(obj => obj.displayname = `${obj.displayname} ${'(' + obj.id + ')(VA-'+obj.UniqueID+')'}`);
            this.selectedrouteDisplayName = val;
            if (data.length == 0) {
              this.notfounddata = true;
            } else {
              this.notfounddata = false
            }
            if(this.isedit && this.RouteNameListPipeline.length>0){
              this.saveSelectedrouteId = this.RouteNameListPipeline[0].id;
              this.saveSelectedrouteDisplayName = this.RouteNameListPipeline[0].displayname;
              this.routeuniqueid=this.RouteNameListPipeline[0].UniqueID;
              this.reactiveFormsubmit.patchValue({
                selectedRouteID:this.saveSelectedrouteDisplayName
              });
              this.RouteNameListPipeline=[];
            }
          },
          error: error => {
            this.ispopup?this.isLoadingResult1=true:this.isLoadingResult = true;
            this.notfounddata = false
            this.toastr.error("Unable to fetch the Pipelines", "", {
              timeOut: 4000,
              positionClass: 'toast-bottom-right'
            });
          }
        });
      }
    }
  }
  buildpiplinetitle(name, id) {
    if (name !== undefined && name != '') {
      if (name.includes("(")) {
        return name
      } else {
        let fullname = name + '(' + id + ')';
        if (id) {
          return fullname;
        }
        else {
          return
        }
      }
    }

  }

  getstringRoute(value) {
    let names = value.split("(")
    value = `${names[0]} <br>(${names[1]} <br>(${names[2]}`
    return value
  }

  getAgentNames(event: any) {
    var val = event;
    if (val) {
      this.ispopup?this.isLoadingagent1=true:this.isLoadingagent = true;

      var apiname = "api/Agents/GetByDisplayName?name=" + val + '&agentid=0&type=&filterflag=true';
      this.isedit?this.ngxUiLoaderService.start():'';
      this.service.getapiurl(apiname).subscribe({
        next: data => {
          this.isedit?this.ngxUiLoaderService.stop():'';
          if ((data['status'] && data['statusText']) || data['statusText'] === "Unknown Error") {
            this.toastr.error("Something Went Wrong!", "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          }
          else {
            this.AgentNameList = data as any[];
            this.AgentNameList = this.service.transformAlphabetically(this.AgentNameList, 'displayname');
            this.AgentNameList.map(obj => obj.displayname = `${obj.displayname} ${'('} ${obj.id} ${')'} ${'('} ${obj.apikey} ${')'}`);
            this.ispopup?this.isLoadingagent1=false:this.isLoadingagent = false;
            if (data.length == 0) {
              this.notfounddata = true;
            }
            else {
              this.notfounddata = false;
            }
            if(this.isedit && this.AgentNameList.length==1)
              {
                this.saveSelectedAgentguid = this.AgentNameList[0].id;
                this.saveSelectedAgentName = this.AgentNameList[0].displayname;
                this.agentuniqueid=this.AgentNameList[0].UniqueID;
                this.reactiveFormsubmit.patchValue({
                  selectedAgentID:this.AgentNameList[0].displayname
                });
                this.AgentNameList=[];
              }
          }
        },
        error: error => {
          this.ispopup?this.isLoadingagent1=true:this.isLoadingagent = true;
          this.notfounddata = true;
        }
      });
    }
  }
  selectedAgent(data) {
    this.selectedAgentguid = data.id;
    this.selectedAgentName = data.displayname;
    this.agentuniqueid=data.UniqueID;
  }
  saveSelectedAgent(data){
this.saveSelectedAgentguid = data.id;
    this.saveSelectedAgentName = data.displayname;
    this.agentuniqueid=data.UniqueID;
  }
  saveSearchAgentNameCleared(){
    this.reactiveFormsubmit.patchValue({
      selectedAgentID:''
    });
    this.AgentNameList = [];
    this.saveSelectedAgentguid = '';
    this.saveSelectedAgentName = '';
  }
  searchAgentNameCleared() {
    this.isLoadingagent = false;
    this.AgentNameList = [];
    this.selectedAgentguid = '';
    this.notfounddata = false;
  }
  selectedinterfaceEvent(item) {
    this.selectedrouteId = item.id;
    this.selectedrouteDisplayName = item.displayname;
    this.routeuniqueid=item.UniqueID;
    this.pipelineselectclass = 'ng-autocompleteselect';
  }
  saveSelectedinterfaceEvent(data){

    this.saveSelectedrouteId = data.id;
    this.saveSelectedrouteDisplayName = data.displayname;
    this.routeuniqueid=data.UniqueID;
  }
  saveSearchRouteNameCleared(){
    this.reactiveFormsubmit.patchValue({
      selectedRouteID:''
    });
    this.saveSelectedrouteId ='';
    this.saveSelectedrouteDisplayName = '';
  }
  async searchRouteNameCleared(event) {
    this.selectedrouteId = '';
    this.selectedrouteDisplayName = '';
    this.reactiveFormroute.reset();
  }
  getAgentendpointdata(){ 
    this.isselect='';
    this.dynamicWidth= (100/this.agentendpointheader.length).toString()+'%';
    if(this.selectedAgentguid !='' || this.selectedrouteId!='')
    {
    this.agentendpointlist=[];
    let obj={
      "routeId":this.selectedrouteId,
      "agentId":this.selectedAgentguid
    }
    this.ngxUiLoaderService.start();
    this.service.GetAgentEndpoint(obj).subscribe((data)=>{
      this.ngxUiLoaderService.stop();
      if(data.length>0){
        this.agentendpointlist=data;
        this.agentendpointlist.forEach(V=>{
          V['active']=false;
          if (typeof V['Params'] === "string" && V['Params'].startsWith('{')){
            V['Params']=JSON.stringify(JSON.parse(V['Params']), null, 2);
          }
        });
      }else{
        this.toastr.warning(
          "No records found","",{
            timeOut: 4000,
            positionClass: 'toast-bottom-right'
          });
      }
    });
    
  }else{
    this.toastr.warning(
      "Required fields are empty","",{
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
  }
  }
  copyToClip(event: any, message) {
    if (event != '') {
      copyToClipboard(event);
      this.toastr.success(message + " " + 'Copied', "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
  }
    modalRef!: NgbModalRef;
  editAgentEndpoint(agentendpointpopup,agent,isedit:boolean){
    this.isedit=isedit;
    this.ispopup=true;
    this.modalHeader="Create agent endpoint";
    if(isedit){
      this.reactiveFormsubmit.patchValue({
        selectedAgentID: agent.agentId,
      selectedRouteID:agent.routeId,
      selectedUrlKey:agent.urlKey,
      selectedUrlValue:agent.urlValue,
      Params:agent.paramss
      });
      this.modalHeader="Edit agent endpoint";
      this.getRouteName(this.reactiveFormsubmit.value.selectedRouteID);
      this.getAgentNames(this.reactiveFormsubmit.value.selectedAgentID);
      this.isselect = agent.id
  }
      this.modalRef=this.modalService
      .open(agentendpointpopup, {
        windowClass: "agentendpointpopup",
        backdrop: "static",
        keyboard: false,
      })
  }
  closeSaveAgent() {
    this.modalRef.close();
    this.reactiveFormsubmit.reset();
    this.saveSelectedrouteId='';
    this.saveSelectedrouteDisplayName='';
    this.saveSelectedAgentguid='';
    this.routeuniqueid='';
    this.agentuniqueid='';
    this.isedit=false;
    }
  async deleteAgentEndpoint(agent){
    let obj={      
        "id":agent.id,
        "modifierid":JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
        .userdata["userid"]
    }
    const message = `Are you sure you want to delete this item?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message, 'confirm', '');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: "500px", data: dialogData, disableClose: true });
    const dialogResult = await dialogRef.afterClosed().toPromise();
    if (dialogResult === false) {
      return;
    }
    this.ngxUiLoaderService.start();

    this.service.DeleteAgentEndpoint(obj).subscribe((data)=>{
      this.ngxUiLoaderService.stop();
      if(data['status'].toLowerCase()=='success'){
        this.toastr.success("Deleted successfully", "", {
          positionClass: "toast-bottom-right",
          timeOut: 4000,
        });
       if(this.reactiveFormagent.value.agentname!='' || this.reactiveFormroute.value.routename!=''){
            this.getAgentendpointdata();
          }
      }
      else{
        this.toastr.success(data['statusmessage'], "", {
          positionClass: "toast-bottom-right",
          timeOut: 4000,
        });
      }
    });
  }
  saveAgentEndpoint(){
    if(this.reactiveFormsubmit.status  == "INVALID")
    {
      this.toastr.warning("Required fields are empty", "", {
        positionClass: "toast-bottom-right",
        timeOut: 4000,
      });
    }else{
      let obj={
        "routeId":this.ispopup?this.saveSelectedrouteId:this.selectedrouteId,
        "agentId":this.ispopup?this.saveSelectedAgentguid:this.selectedAgentguid,
        "urlKey":this.reactiveFormsubmit.value.selectedUrlKey,
        "urlValue":this.reactiveFormsubmit.value.selectedUrlValue,
        "paramss":this.reactiveFormsubmit.value.Params,
        "id":this.isedit?this.isselect:0,
        "routeUniqueId":this.routeuniqueid,
        "agentUniqueId":this.agentuniqueid,
        "modifierid":JSON.parse(sessionStorage.getItem("sessionObjectlogin"))
        .userdata["userid"]
      };
      if(obj['agentId'] == '' || obj['agentId'] == null){
        this.toastr.warning("Select agent", "", {
          positionClass: "toast-bottom-right",
          timeOut: 4000,
        });
        return;
      }else{
      this.ngxUiLoaderService.start();
      this.service.SaveAgentEndPoint(obj).subscribe((data)=>{
        this.ngxUiLoaderService.stop();
        if(data['status'].toLowerCase()=='success')
        {
          this.toastr.success("Saved successfully", "", {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          });
          this.closeSaveAgent();
          if(this.reactiveFormagent.value.agentname!='' || this.reactiveFormroute.value.routename!=''){
            this.getAgentendpointdata();
          }
        }else{
          this.toastr.error(data['statusmessage'], "", {
            positionClass: "toast-bottom-right",
            timeOut: 4000,
          });
        }
      });
    }
  }
  }
  reset(){
    this.reactiveFormagent.reset();
    this.reactiveFormroute.reset();
    this.AgentNameList=[];
    this.selectedAgentguid = '';
    this.selectedAgentName = '';
    this.selectedrouteId = '';
    this.selectedrouteDisplayName = '';
    this.agentendpointlist=[];
    this.isedit=false;
    this.saveSelectedrouteId='';
    this.saveSelectedrouteDisplayName='';
    this.saveSelectedAgentguid='';
    this.routeuniqueid='';
    this.agentuniqueid='';
    this.isselect='';
  }
}
